import appendQueryString from './appendQueryString'
import composeQueryString from './composeQueryString'
import { Params } from './types'

/**
 * Appends querystring params to a URL.
 *
 * @param url A URL like 'http://www.anything.com' or 'anything.com?existingParam=someValue'.
 * @param params Params like { skip: 0, take: 50 } or { needsEncoding: 'a value' }
 * @param encode Should the param names and values be URI encoded? Set to false for performance gains if you are sure the names and values are URI safe.
 * @return  A URL like 'anything.com?existingParam=someValue&needsEncoding=a%20value'
 */
export default (url: string, params: Params, encode: boolean = true) => {
	if (!params) {
		return url
	}
	const encodedParams = composeQueryString(params, encode)
	return appendQueryString(url, encodedParams)
}
